package ru.villawonka.app.presentation.screens.postCard.compose.layout

import androidx.compose.material.MaterialTheme
import androidx.compose.material.Scaffold
import androidx.compose.material.TopAppBar
import androidx.compose.runtime.Composable
import cafe.adriel.voyager.navigator.LocalNavigator
import ru.villawonka.app.getTelegram
import ru.villawonka.app.presentation.design.components.AppOutlinedIconButton
import ru.villawonka.app.presentation.design.theme.surfaceMiddle
import ru.villawonka.app.presentation.screens.postCard.compose.PostCardCallbacks
import ru.villawonka.app.presentation.screens.postCard.viewmodel.PostCardUIState
import ru.villawonka.app.presentation.sharedviews.DefaultErrorStateLayout
import ru.villawonka.app.presentation.sharedviews.DefaultLoadingStateLayout
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_nav_arrow_left_24

@Composable
fun PostCardRootLayout(
    state: PostCardUIState,
    callbacks: PostCardCallbacks,
) {
    Scaffold(
        topBar = { TopAppBarView() }
    ) {
        when (state) {
            is PostCardUIState.Error -> DefaultErrorStateLayout( failure = state.failure, onRetryClick = callbacks.onRetryLoad)
            is PostCardUIState.Loading -> DefaultLoadingStateLayout()
            is PostCardUIState.Data -> PostCardDataStateLayout(state, callbacks)
        }
    }
}

@Composable
private fun TopAppBarView() {
    val navigator = LocalNavigator.current
    getTelegram()?.setBackButtonVisible(true) ?: TopAppBar(
        navigationIcon = {
            AppOutlinedIconButton(
                iconRes = Res.drawable.ic_nav_arrow_left_24,
                bordered = false,
                onClick = { navigator?.pop() }
            )
        },
        title = {},
        backgroundColor = MaterialTheme.colors.surfaceMiddle
    )
}